export default __webpack_public_path__ + "static/media/green-bg.72341137.png";